import script from "./GameCards.vue?vue&type=script&setup=true&lang=js"
export * from "./GameCards.vue?vue&type=script&setup=true&lang=js"

import "./GameCards.vue?vue&type=style&index=0&id=5ed22ed5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed22ed5"]])

export default __exports__